import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Modal } from "@/components/Modal";

interface ComingSoonModalProps {
  open: boolean;
  onClose: () => void;
}

export const ComingSoonModal = ({ open, onClose }: ComingSoonModalProps) => {
  const [t] = useTranslation("homeowners");
  const navigate = useNavigate();

  const handleCtaClick = () => {
    onClose();
    navigate("/contact");
  };

  return (
    <Modal
      open={open}
      withClose
      onClose={onClose}
      className="!max-w-md sm:!max-w-lg !px-8 !py-10 sm:!px-12 sm:!py-14"
      closeIconClassName="!text-homeowners-gray"
    >
      <div className="flex flex-col items-center text-center gap-6">
        <h2 className="font-playfair font-semibold text-homeowners-headline text-3xl sm:text-4xl">
          {t("ComingSoon.Title")}
        </h2>
        <p className="font-montserrat text-homeowners-gray text-base sm:text-lg leading-relaxed">
          {t("ComingSoon.Body")}
        </p>
        <button
          onClick={handleCtaClick}
          className="w-full sm:w-auto bg-homeowners-purple text-white font-montserrat font-semibold text-base sm:text-lg px-10 py-4 rounded-xl transition-all duration-[180ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)] hover:brightness-[0.94] hover:-translate-y-[2px] hover:shadow-lg active:translate-y-0 active:shadow-md"
        >
          {t("ComingSoon.Cta")}
        </button>
      </div>
    </Modal>
  );
};
